package cc.bluepeak.clubmanager.site.util

val gsap = js("gsap")
val ScrollTrigger = js("ScrollTrigger")